import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Reveal } from "./Reveal";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";

export default function LocationsSection() {
  const [provinces, setProvinces] = useState([]);

  useEffect(() => {
    api.get("/locations").then((r) => setProvinces(r.data)).catch(() => {});
  }, []);

  return (
    <section
      className="border-t border-white/10 bg-velvet-coal py-24 md:py-40"
      data-testid="locations-section"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal>
          <p className="mb-5 text-xs uppercase tracking-luxe text-velvet-gold">Nationwide</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mb-16 max-w-3xl font-heading text-4xl font-semibold leading-[0.95] tracking-tight text-white md:text-6xl">
            Every city, <span className="italic text-velvet-rose">every town</span>
          </h2>
        </Reveal>

        <Accordion type="single" collapsible className="border-t border-white/10">
          {provinces.map((p) => (
            <AccordionItem key={p.slug} value={p.slug} className="border-b border-white/10">
              <AccordionTrigger
                data-testid={`province-${p.slug}`}
                className="py-6 hover:no-underline [&>svg]:text-velvet-gold"
              >
                <span className="flex items-baseline gap-4 text-left">
                  <span className="font-heading text-2xl font-normal text-white md:text-3xl">{p.name}</span>
                  <span className="text-[10px] uppercase tracking-luxe text-white/40">{p.cities.length} cities</span>
                </span>
              </AccordionTrigger>
              <AccordionContent>
                <div className="grid grid-cols-1 gap-x-10 gap-y-8 pb-10 md:grid-cols-2 lg:grid-cols-3">
                  {p.cities.map((c) => (
                    <div key={c.slug} data-testid={`loc-city-${c.slug}`}>
                      <Link
                        to={`/locations/${c.slug}`}
                        className="font-heading text-lg text-velvet-gold transition-colors duration-300 hover:text-white"
                      >
                        {c.name}
                      </Link>
                      <div className="mt-3 flex flex-wrap gap-x-3 gap-y-2">
                        {c.towns.map((t) => (
                          <Link
                            key={t}
                            to={`/locations/${c.slug}/${encodeURIComponent(t)}`}
                            className="text-sm font-light text-white/45 transition-colors duration-300 hover:text-velvet-rose"
                          >
                            {t}
                          </Link>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
